<template>
    <div>
        <MessageOverlay ref="overlay" />

        <v-row justify="space-around">
            <v-col cols="12" md="6">
                <v-card class="fill-height">
                    <v-card-title class="grey lighten-2 font-weight-bold text-h5">{{ $vuetify.lang.t('$vuetify.support.contactus') }}</v-card-title>
                    <v-card-text class="text-center">
                        <Map :technicalSupportAddress="technicalSupportAddress" />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card class="fill-height">
                    <v-card-title class="grey lighten-2 font-weight-bold text-h5">{{ $vuetify.lang.t('$vuetify.support.reportaproblem') }}</v-card-title>
                    <v-container>
                        <v-card-text class="text-center">
                            <v-form
                                ref="contactForm"
                                v-model="contactForm"
                                lazy-validation
                            >
                                <v-select
                                    v-model="category"
                                    required
                                    outlined
                                    :label="$vuetify.lang.t('$vuetify.support.category')+'*'"
                                    :items="categoryItems"
                                    :rules="categoryRules"
                                ></v-select>
                                <v-text-field
                                    v-model="subject"
                                    required
                                    outlined
                                    :label="$vuetify.lang.t('$vuetify.support.subject')+'*'"
                                    :rules="subjectRules"
                                ></v-text-field>
                                <v-textarea
                                    v-model="message"
                                    required
                                    outlined
                                    no-resize
                                    rows="6"
                                    :label="$vuetify.lang.t('$vuetify.support.yourmessage')+'*'"
                                    :rules="messageRules"
                                ></v-textarea>
                                <v-file-input
                                    v-model="files"
                                    outlined
                                    counter
                                    multiple
                                    prepend-icon=""
                                    prepend-inner-icon="mdi-paperclip"
                                    placeholder="Select your files"
                                    :show-size="1000"
                                    :label="$vuetify.lang.t('$vuetify.support.fileinput')"
                                >
                                    <template v-slot:selection="{ index, text }">
                                        <v-chip
                                            v-if="index < 2"
                                            color="grey"
                                            dark
                                            label
                                            small
                                        >
                                            {{ text }}
                                        </v-chip>
                                        <span
                                            v-else-if="index === 2"
                                            class="text-overline grey--text text--darken-3 mx-2"
                                        >
                                            +{{ files.length - 2 }} File(s)
                                        </span>
                                    </template>
                                </v-file-input>
                                <v-btn
                                    :disabled="isFormValid || reportButtonLoading"
                                    :loading="reportButtonLoading"
                                    class="mr-4"
                                    :class="isFormValid || reportButtonLoading ? '' : 'gradient-wintech'"
                                    @click="validate"
                                >
                                    <v-icon left>mdi-receipt-text-send</v-icon>
                                    {{ $vuetify.lang.t('$vuetify.support.report') }}
                                </v-btn>
                            </v-form>
                        </v-card-text>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from 'axios';
import Map from './Support/Map';
import { mapGetters } from 'vuex';
import MessageOverlay from './Overlay/MessageOverlay.vue';
export default {
    name: "Support",
    components: {
        Map,
        MessageOverlay
    },
    data() {
        return {
            contactForm: true,
            category: "",
            categoryRules: [v => !!v || this.$vuetify.lang.t('$vuetify.support.categoryisrequired')],
            categoryItems: [
                this.$vuetify.lang.t('$vuetify.support.utcsensor'),
                this.$vuetify.lang.t('$vuetify.support.webpage'),
                this.$vuetify.lang.t('$vuetify.support.othersubject')
            ],
            subject: "",
            subjectRules: [v => !!v || this.$vuetify.lang.t('$vuetify.support.subjectisrequired')],
            message: "",
            messageRules: [v => !!v || this.$vuetify.lang.t('$vuetify.support.messageisrequired')],
            files: [],
            reportButtonLoading: false,
            technicalSupportAddress: ""
        }
    },
    computed: {
        ...mapGetters({ user: "StateUser" }),
        isFormValid() {
            return !(this.categoryRules && this.subjectRules && this.messageRules && this.message && this.category && this.subject)
        }
    },
    async created() {
        try {
            const res = await axios.get('support');
            if (res.status == 200) {
                this.technicalSupportAddress = res.data.address;
            }
        } catch(err){
            console.error(err.response.status)
        }
    },
    methods: {
        async validate() {
            this.reportButtonLoading = true;
            if (this.$refs.contactForm.validate()) {
                const data = new FormData();
                data.append("category", this.category);
                data.append("subject", this.subject);
                data.append("message", this.message);
                data.append("user_username", this.user.username);
                data.append("user_mail", this.user.email);
                data.append("user_orga", this.user.orga);
                data.append("user_orgaName", this.user.orgaName);
                for (let file of this.files) {
                    data.append("files", file, file.name);
                }
                try {
                    const res = await axios.post('support', data);
                    if (res.status == 200) {
                        this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.support.supportmailOK'), 4000)
                        this.reset();
                    } else {
                        this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.support.supportmailNOK'), 4000)
                    }
                } catch(err){
                    console.error(err.response.status)
                }
            }
            this.reportButtonLoading = false;
        },
        reset() {
            this.$refs.contactForm.reset()
        },
        resetValidation() {
            this.$refs.contactForm.resetValidation()
        },
    },
}
</script>